export const filterConfig = [
    {
        id: 'customerName',
        label: 'Patient Name',
        type: 'text',
        placeholder: 'Search by patient name...',
    },
    {
        id: 'doctorName',
        label: 'Doctor Name',
        type: 'text',
        placeholder: 'Search by doctor name...',
    },
    {
        id: 'consultationType',
        label: 'Consultation Type',
        type: 'text',
        placeholder: 'Search by consultation type...',
    },
    {
        id: 'phoneNo',
        label: 'Phone No',
        type: 'text',
        placeholder: 'Search by phone number...',
    },
    // {
    //     id: 'registrationNo',
    //     label: 'CasePaperID',
    //     type: 'text',
    //     placeholder: 'Search by case paper ID...',
    // },
    {
        id: 'status',
        label: 'Status',
        type: 'select',
        options: [
            { value: 'Upcoming', label: 'Upcoming' },
            { value: 'Completed', label: 'Completed' },
            { value: 'Cancelled', label: 'Cancelled' },
        ],
    },
    {
        id: 'dateRange',
        label: 'Appointment Date',
        type: 'dateRange',
        quickFilters: ['today', 'yesterday', 'last7days', 'last30days'],
    },
];

export const summaryConfig = [
    {
        key: 'total',
        type: 'count',
        title: 'Total Appointments',
        icon: 'calendar',
        color: 'info',
    },
    {
        key: 'upcoming',
        type: 'countBy',
        field: 'status',
        value: 'Upcoming',
        title: 'Upcoming',
        icon: 'clock',
        color: 'warning',
    },
    {
        key: 'completed',
        type: 'countBy',
        field: 'status',
        value: 'Completed',
        title: 'Completed',
        icon: 'check-circle',
        color: 'success',
    },
    {
        key: 'cancelled',
        type: 'countBy',
        field: 'status',
        value: 'Cancelled',
        title: 'Cancelled',
        icon: 'x-circle',
        color: 'error',
    },
];

export const defaultSort = { field: 'date', order: 'desc' };
